import { useCachedUserType } from 'hooks/api/cached/useCashedUserType';
import { SubscriptionState } from 'store/api/apiTypes';
import {
  useGetStandaloneSubscriptionsQuery,
  useGetSubscriptionsQuery,
} from 'store/api/userApiSlice';
export const useSubscriptions = (showTrial?: boolean) => {
  const { isKa, isDirect } = useCachedUserType();
  const standaloneResult = useGetStandaloneSubscriptionsQuery(showTrial, {
    skip: !isDirect,
    refetchOnMountOrArgChange: true,
  });
  const kaResult = useGetSubscriptionsQuery(showTrial, {
    skip: !isKa,
    refetchOnMountOrArgChange: true,
  });

  const { data, isLoading, isFetching, error } = isDirect
    ? standaloneResult
    : kaResult;
  const terminated =
    data?.subscriptions.filter(
      sub =>
        sub.license.state === SubscriptionState.TERMINATED && !!sub.domain?.name
    ) ?? [];
  const active =
    data?.subscriptions.filter(
      sub => sub.license.state !== SubscriptionState.TERMINATED
    ) ?? [];
  const nextBillingDate = data?.subscriptions.filter(
    sub => sub.license.next_billing_date
  );
  const storeUrl = data?.info?.store_url;
  return {
    isLoading,
    isFetching,
    error,
    subscriptions: data?.subscriptions,
    active,
    terminated,
    count: data?.count,
    storeUrl,
    nextBillingDate,
  };
};
